import { useState, useMemo } from '@wordpress/element';
import { Button } from '@wordpress/components';
import { MdCancel } from 'react-icons/md';
import { InserterModal as Inserter } from '../../block/icon/components';
import { flattenIconsArray } from '../../block/icon/utils';
import { defaultIcon } from '../../block/icon/icons/default';
import getIcons from '../../block/icon/icons';

export const IconSelector = ({ value = {}, onChange, attributes, setAttributes }) => {
	const [isInserterOpen, setInserterOpen] = useState(false);
	const iconsAll = useMemo(() => flattenIconsArray(getIcons()), []);

	const namedIcon = iconsAll.find((i) => i.name === value.iconName);
	const printedIcon = namedIcon?.icon || defaultIcon;

	return (

		<div className="vb-inserter-wrapper-compo">
			{ !value.iconName ? (
				<div
					style={{ paddingBottom: '15px'}}
					className="vb-inserter-placeholder"
					onClick={() => setInserterOpen(true)}
				>
					<Button
						variant="secondary"
						className="vb-inserter-button"
						onClick={() => setInserterOpen(true)}
					>
						+ Add Icon
					</Button>
					
				</div>
			) : (
				<div className="vb-inserter-icon-box" >
					<div className="vb-inserter-icon-preview">{printedIcon}</div>
					<Button
						variant="secondary"
						className="vb-inserter-button"
						onClick={() => setInserterOpen(true)}
					>
						Change Icon
					</Button>
				</div>
			)}

			<Inserter
				isInserterOpen={isInserterOpen}
				setInserterOpen={setInserterOpen}
				attributes={attributes || { iconName: value.iconName }}
				setAttributes={setAttributes ||((val) => {if (val?.iconName) {onChange?.({iconName: val.iconName});}})}
			/>

			<div className="vb-inserter-remove" onClick={() => setInserterOpen(true)}>
				<MdCancel />
			</div>
		</div>
	);
};

// const [iconData, setIconData] = useState({
// 		iconName: 'wordpress-calendar',
// 	});

// 	<IconSelector
// 		value={iconData}
// 		onChange={(val) => setIconData(val)}
// 	/>

// ***************or********************
// <IconSelector
// 	value={{ iconName: attributes.activeiconName}}
// 	onChange={(val) => setAttributes({activeiconName: val.iconName})}
// />

// JSON
// ******put normal string here
//     "activeiconName": {
// 		"type": "string",
// 		"default":"wordpress-chevronUp"
// 	},